import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const designerAPI = {
  getProfile: () => api.get('/designer/profile'),
  updateProfile: (data) => api.put('/designer/profile', data),
  getPublicProfile: (designerId) => api.get(`/designer/${designerId}/public`),
};

export const servicesAPI = {
  getAll: () => api.get('/services'),
  create: (data) => api.post('/services', data),
  update: (id, data) => api.put(`/services/${id}`, data),
  delete: (id) => api.delete(`/services/${id}`),
};

export const portfolioAPI = {
  getAll: () => api.get('/portfolio'),
  add: (data) => api.post('/portfolio', data),
  delete: (id) => api.delete(`/portfolio/${id}`),
};

export const leadsAPI = {
  getAll: () => api.get('/leads'),
  create: (data) => api.post('/leads', data),
  update: (id, data) => api.put(`/leads/${id}`, data),
  delete: (id) => api.delete(`/leads/${id}`),
};

export const customersAPI = {
  getAll: () => api.get('/customers'),
  getOne: (id) => api.get(`/customers/${id}`),
  create: (data) => api.post('/customers', data),
};

export const invoicesAPI = {
  getAll: () => api.get('/invoices'),
  getOutstanding: () => api.get('/invoices/outstanding'),
  getOne: (id) => api.get(`/invoices/${id}`),
  create: (data) => api.post('/invoices', data),
  updatePayment: (id, advancePaid) => api.put(`/invoices/${id}`, null, { params: { advance_paid: advancePaid } }),
};

export const reviewsAPI = {
  getAll: () => api.get('/reviews'),
  create: (data) => api.post('/reviews', data),
  delete: (id) => api.delete(`/reviews/${id}`),
};

export const dashboardAPI = {
  getStats: () => api.get('/dashboard/stats'),
};

// Ticket/Support APIs
export const ticketsAPI = {
  create: (data) => api.post('/tickets', data),
  getAll: () => api.get('/tickets'),
  getOne: (id) => api.get(`/tickets/${id}`),
  addMessage: (id, data) => api.post(`/tickets/${id}/messages`, data),
};

// Market Source APIs
export const marketLinksAPI = {
  getAll: () => api.get('/market-links'),
};

// Admin APIs
export const adminAPI = {
  login: (data) => api.post('/admin/login', data),
  getDesigners: () => api.get('/admin/designers'),
  getStats: () => api.get('/admin/stats'),
  // Tickets
  getTickets: () => api.get('/admin/tickets'),
  getTicket: (id) => api.get(`/admin/tickets/${id}`),
  updateTicketStatus: (id, status) => api.put(`/admin/tickets/${id}/status?status=${status}`),
  addTicketMessage: (id, data) => api.post(`/admin/tickets/${id}/messages`, data),
  // Market Links
  getMarketLinks: () => api.get('/admin/market-links'),
  createMarketLink: (data) => api.post('/admin/market-links', data),
  deleteMarketLink: (id) => api.delete(`/admin/market-links/${id}`),
};

export default api;